import React, {Component} from 'react'
import PropTypes from 'prop-types'

class OrdersError extends Component {
    render() {
        return (
            <tr className='OrdersError'>
                <td colSpan={14}>
                    <div className='text-danger'>
                        <span className='font-weight-bold'>ERROR:</span> {this.props.error}
                    </div>
                </td>
            </tr>
        )
    }
}

OrdersError.propTypes = {
    error: PropTypes.string.isRequired,
}

export default OrdersError
